import { __assign } from "tslib";
import * as React from 'react';
export var ButtonRow = function (props) {
    return React.createElement("div", __assign({}, props, { className: "button-row ".concat(props.className || '') }));
};
//# sourceMappingURL=index.js.map